// register-footer v1: 注册页面底部组件
// 从 RegisterPage.js 中提取的底部区域

import React, { useState } from 'react';

import PrivacyPolicyModal from './PrivacyPolicyModal';
import TermsOfServiceModal from './TermsOfServiceModal';

/**
 * RegisterFooter 组件 - 注册页面底部区域
 * @param {Object} props - 组件属性
 * @param {Function} props.onLoginClick - 登录点击处理函数
 * @returns {JSX.Element} 底部组件
 */
const RegisterFooter = ({ onLoginClick }) => {
  const [showPrivacyModal, setShowPrivacyModal] = useState(false);
  const [showTermsModal, setShowTermsModal] = useState(false);

  const handlePrivacyClick = () => {
    setShowPrivacyModal(true);
  };

  const handleTermsClick = () => {
    setShowTermsModal(true);
  };

  return (
    <>
      {/* Bottom Options */}
      <div className='mt-6 flex justify-center'>
        <button
          onClick={onLoginClick}
          className='w-full flex justify-center py-3 px-4 border border-white rounded-md shadow-sm text-sm font-light text-white bg-transparent hover:bg-gradient-to-r hover:from-blue-500 hover:to-purple-600 hover:text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-tag-blue transition-all duration-200'
        >
          Login
        </button>
      </div>

      {/* 彈窗組件 */}
      <PrivacyPolicyModal
        isOpen={showPrivacyModal}
        onClose={() => setShowPrivacyModal(false)}
      />
      <TermsOfServiceModal
        isOpen={showTermsModal}
        onClose={() => setShowTermsModal(false)}
      />
    </>
  );
};

export default RegisterFooter;
